<template>
    <Header ueberschrift="Geräteverwaltung" />
    <div id="geraeteverwaltung">
      <span v-for="geraet in this.geraete" :key="geraet.geraetId">
        <Geraet :geraet="geraet" @updateGeraetTable="this.refreshGeraete()"/>
      </span>
      <button class="plus-button" @click="this.neuesGeraetFormular()">+</button>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Geraet from "@/components/Geraet.vue";
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: "GeraeteVerwaltung",
  components: {
    Header,
    Footer,
    Geraet,
  },
  props: {
    
  },
  data() {
    return {
      geraete: [],
    };
  },
  methods: {

    async getGeraete() {
      try {
        const response = await axios.get(
          'https://feuerwehr-server.org:5000/geraet'
        );
        console.log(response.data);
        response.data.sort((a, b) => a.name.localeCompare(b.name));
        return response.data;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    async neuesGeraetFormular() {
      console.log("Test");
    var html = "";
    html += `<input style="width: 100%" id="name" maxLength="50" class="swal2-input" placeholder="Bezeichnung" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important">`;
    html += `<input type="file" id="file" class="swal2-input" placeholder="Bild hochladen">`;

    const { value: formValues } = await Swal.fire({
        title: "Geraet anlegen",
        html: html,
        focusConfirm: false,
        preConfirm: () => {
            const file = document.getElementById("file").files[0];
            const name = document.getElementById("name").value;
            return { name, file };
        }
    });

    if (formValues) {
        const file = formValues.file;
        const name = formValues.name;

        // FormData erstellen, um Bild zu senden
        const formData = new FormData();
        formData.append('file', file);

        // Upload der Datei ans Backend
        try {
            const response = await fetch('https://feuerwehr-server.org:5000/upload-image-endpoint', {
                method: 'POST',
                body: formData
            });

            const result = await response.json(); // der Pfad oder das Ergebnis vom Backend
            if (result.success) {
                // Wenn der Upload erfolgreich war, Geraet anlegen
                const imagePath = result.filePath; // Bildpfad vom Backend
                this.createGeraet(name, imagePath); // Geraet mit Bildpfad erstellen
            }
        } catch (error) {
            console.error('Error uploading the file:', error);
        }
    }
},
    async getMaxGeraetID() {
      try {
        const response = await axios.get(
          'https://feuerwehr-server.org:5000/maxGeraetID'
        );
        console.log(response.data);
        return response.data.maxGeraetID;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    async createGeraet(bezeichnung, imagePath){
      var geraetID = await this.getMaxGeraetID() + 1;
      console.log(geraetID);
      const geraetData = {
        name: bezeichnung,
        imagePath: imagePath,
        geraetID: geraetID,
      };

      axios.post('https://feuerwehr-server.org:5000/addGeraet', geraetData)
        .then(response => {
            console.log('Erfolgreich registriertes Gerät:', response.data);
            // Hier könntest du entsprechende Aktionen ausführen, z.B. Benutzer weiterleiten, eine Erfolgsmeldung anzeigen, etc.
            this.refreshGeraete();
        })
        .catch(error => {
            console.error('Fehler bei der Gerätregistrierung:', error.response.data);
            Swal.fire("Es ist ein Fehler aufgetreten", "Bitte wenden Sie sich an den Administrator", "error");
            // Hier könntest du Fehlerhandhabung durchführen, z.B. eine Fehlermeldung anzeigen, den Benutzer dazu auffordern, es erneut zu versuchen, etc.
        });
    },
    async refreshGeraete(){
      this.geraete = [];
      this.geraete = await this.getGeraete();
    }
  },
  async created(){
    //console.log(this.benutzer.data);
    this.geraete = await this.getGeraete();
  },
  setup() {
    const emits = ['updateGeraetTable'];
    return { emits };
  }
};
</script>

<style lang="scss">
#geraeteverwaltung{
    margin-top: 5.5rem;
    //max-height: 500px;
    height: 82vh;
    overflow-y: auto;

    button{
      margin-top: 0.4rem;
      padding: 0.2rem !important;
      width: 3.8rem !important;
      height: 3.8rem !important;
      line-height:0;
    }

    .plus-button{
      font-size: 3.6rem;
      color: white;
      background-color: blue;
      border-radius: 0.5rem;
      font-weight: bold;
    }
}

@media screen and (max-height: 768px) {
  #geraeteverwaltung{
    margin-bottom: 10vh;
  }
}
</style>
